<div class="flex-row align-center row success-bg">
  <img class="vertical-middle" src="../../../assets/img/Megaphone.svg" />
  <div class="text vertical-middle">{{data.contentText}}</div>

  <mat-icon class="clickable" (click)="dismiss()">close</mat-icon>
</div>
